<template>
  <div id="app" style="font-family: 'Noto Sans KR', sans-serif !important">
    <router-view class="innerWrap" :key="$route.fullPath" />
    <LoadingOverlay v-if="_state.loadingBool" />
    <ProgressOverlay v-if="_progress.state" />

    <transition name="slide-fade">
      <ToasMessage v-if="_state.toastBool" />
    </transition>
    <Alert v-if="_modal.modalState" />
  </div>
</template>

<script>
// require('./assets/css/style.css')
import LoadingOverlay from "@/components/Common/Loading.vue";
import ProgressOverlay from "@/components/Common/Progress.vue";
import ToasMessage from "@/components/Common/ToastMessage.vue";
import Alert from "@/components/Common/Alert.vue";
import { mapState } from "vuex";
export default {
  name: "App",
  components: {
    LoadingOverlay,
    ProgressOverlay,
    ToasMessage,
    Alert,
  },
  created() {
    // if (localStorage.ad_to_ac_se) {
    //     this.$store.state._state.loginState = true
    // }
  },
  mounted() {},
  computed: {
    ...mapState(["_state", "_modal"]),
    ...mapState("reportStore", ["report", "_progress"]),
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
